// Fields that are internal bookkeeping, not meaningful to show as a "change"
// in an audit view.
const NOISE_FIELDS = new Set([
  "id",
  "createdAt",
  "updatedAt",
  "docHash",
  "sifra",
  "searchVector",
]);

const isDataUri = (value) =>
  typeof value === "string" && value.startsWith("data:image");

// pre/posle are full-row snapshots (not diffs), so most fields are identical
// between them on any given change. Only surface the ones that actually
// differ, skipping noise fields — this is what turns a raw snapshot pair
// into a readable "what changed" list.
export const diffFields = (pre, posle) => {
  if (!pre || !posle) return [];
  const keys = new Set([...Object.keys(pre), ...Object.keys(posle)]);
  const rows = [];

  keys.forEach((key) => {
    if (NOISE_FIELDS.has(key)) return;
    const before = pre[key];
    const after = posle[key];
    if (JSON.stringify(before) === JSON.stringify(after)) return;
    rows.push({ field: key, before, after, isImage: isDataUri(before) || isDataUri(after) });
  });

  return rows;
};

export { isDataUri };
